<template>
  <div class="animated fadeIn">
    <b-card>
      <b-col sm="12" class="TitleCard">
        <h4 id="traffic" class="card-title mb-0">Most visited pages of the site</h4>
      </b-col>
      <b-container>
        <b-row>
          <b-col cols="12" v-for="item in items" v-bind:key="item.id">
            <div style="margin:2%">
              <div class="progress-group-header" style="flex-direction:column">
                <small
                  class="ml-auto font-weight-bold"
                >{{item.numVisitas}} Views</small>
                <small
                  class="text-muted small"
                >&nbsp;({{ Math.round((100 * item.numVisitas) / total) }}%)</small>
              </div>
              <div class="progress-group-prepend">
                <span class="progress-group-text" style="font-size: 12px">
                  <p
                    class="link"
                    :href="item.url"
                    v-on:click="openNewWindow(item.url)"
                  >{{ item.url }}</p>
                </span>
              </div>
              <div class="progress-group mb-4">
                <div class="progress-group-bars">
                  <b-progress
                    class="progress-xs"
                    variant="info"
                    :value="(100 * item.numVisitas) / total"
                    height="{}"
                  />
                </div>
              </div>
            </div>
          </b-col>
        </b-row>
      </b-container>
    </b-card>
  </div>
</template>

<script>
import { Callout } from '@coreui/vue';
import http from '../../http';

export default {
  name: 'listaPaginas',
  components: {
    Callout,
  },
  data() {
    return {
      items: [],
      total: 0,
    };
  },
  async mounted() {
    try {
      const response = await http.get('/secured/paginasMaisVisitadas');
      response.data.forEach((element) => (this.total += element.numVisitas));
      this.items = response.data;
    } catch (error) {

    }
  },
  methods: {
    openNewWindow(item) {
      window.open(item);
    },
  },
};

</script>

<style>
  #card-chart-01 {
    width: 100% !important;
  }
  .TitleCard {
    margin-bottom: 05%;
  }
  .link {
    color: #000;
    cursor: pointer;
  }
  .link:hover {
    color: #000;
    text-decoration: none;
  }
</style>
